"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FormElement = exports.Sections = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var FontSizes = {
  small: _stylers["default"].fontSize(-2),
  medium: _stylers["default"].fontSize(-1),
  large: _stylers["default"].fontSize(0)
};

var Sections = _styledComponents["default"].div.withConfig({
  displayName: "FormElementstyles__Sections",
  componentId: "c4la3x-0"
})(function (_ref) {
  var isInline = _ref.isInline;
  return (0, _styledComponents.css)(["", ""], isInline && "flex-grow: 1;");
});

exports.Sections = Sections;
var inlineFormElementStyles = (0, _styledComponents.css)(["align-items:baseline;display:flex;"]);

var FormElement = _styledComponents["default"].div.withConfig({
  displayName: "FormElementstyles__FormElement",
  componentId: "c4la3x-1"
})(function (_ref2) {
  var size = _ref2.size,
      isInline = _ref2.isInline,
      isDisabled = _ref2.isDisabled;
  return (0, _styledComponents.css)(["", " ", ";", " border:none;margin:0;padding:0;"], FontSizes[size], isInline && inlineFormElementStyles, isDisabled && "opacity: 0.5;");
});

exports.FormElement = FormElement;
//# sourceMappingURL=FormElement.styles.js.map